import React, { Component } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { sanitize } from "../export-button/ExportButton";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {
  stringToDate,
  minDate,
  isThisDuplicate,
  collectFootnotes,
} from "../utils/utilities";
import { separateSegments, verifyColumns } from "../utils/dataService";
import mapSegment from "../utils/mapSegment";
import InvalidRecords from "../InvalidRecords";
import Footnotes from "../footnotes/Footnotes";
import BoxSizeControl from './BoxSizeControl';
import InvalidReport from "../groupReports/InvalidReport";
import ReportBase from "../groupReports/ReportBase";
import "./styles.scss";
import RedirectToTm from "./RedirectToTm";
import Segment, { collectDistinctSegments, SwitchColor } from "./Segments";

class AtaxiaCompetitorUniverse extends Component {
  footnotesColumnName = "report-1-footnotes";
  state = { formated: null, boxSize: { height: 180, width: 185 }, notAvailable: [], randomColors: false };

  headersAsKeys = [
    "H/M/L; New; NA",
    "NCT link",
    "Compound phase",
    "Product name",
    "MOA (Revised)",
    "Company Name",
    "Segment",
    "Condition treated",
    "Est. Launch",
  ];

  invalidHeaders = [
    "H/M/L; New; NA",
    "NCT link",
    "Compound phase",
    "Product name",
    "MOA (Revised)",
    "Company Name",
    "Segment",
    "Est. Launch",
    "Duplicated",
  ];

  formated = {
    "Pre-Clinical": { visibility: false, value: [] },
    "Phase I": { visibility: true, value: [] },
    "Phase II": { visibility: true, value: [] },
    "Phase III": { visibility: true, value: [] },
    Filed: { visibility: false, value: [] },
    "Approved or Marketed": { visibility: false, value: [] },
  };

  // leftBehindHeaders = ["H/M/L; New; NA", "NCT link", "Product name"];

  leftBehind = [];
  footnotes = [];
  generalFootnotes = [];
  data = null;

  validation() {
    const notAvailable = verifyColumns(this.props.data);
    if (notAvailable.length) {
      this.setState({ notAvailable })
      return false;
    }
    return true;
  }

  componentDidMount() {
    this.data = this.props.data;
    if (!this.validation()) return;

    this.data = separateSegments(this.data);

    const fileHeaders = this.data[0];
    let auxBody = [];
    this.data.forEach((row, index) => {
      if (index === 0) return;

      const processedObject = row.reduce((object, cell, index) => {
        object[fileHeaders[index]] = cell;
        return object;
      }, {});

      //collecting general footnotes
      if (processedObject["report-1-general-footnotes"]) {
        this.generalFootnotes.push(
          processedObject["report-1-general-footnotes"]
        );
      }

      if (["HH", "Medium", "Low"].includes(processedObject["H/M/L; New; NA"])) {
        const isDuplicate = isThisDuplicate(auxBody, processedObject);
        if (isDuplicate) {
          const oldOnesDate = stringToDate(
            auxBody[isDuplicate.index]["Est. Launch"]
          );
          const newOnesDate = stringToDate(processedObject["Est. Launch"]);

          // replacing product with min date
          if (minDate(oldOnesDate, newOnesDate) === newOnesDate) {
            auxBody[isDuplicate.index].Duplicated = "Yes";
            this.leftBehind.push(auxBody[isDuplicate.index]);
            auxBody.splice(isDuplicate.index, 1);
            auxBody.push(processedObject);
            return;
          }

          processedObject.Duplicated = "Yes";
          this.leftBehind.push(processedObject);
          return;
        }

        auxBody.push(processedObject);
      } else {
        this.leftBehind.push(processedObject);
      }
    });

    // collecting distinct segments
    this.distinctSegments = collectDistinctSegments(auxBody);
    // console.log(this.distinctSegments)

    //Ditinct Product rule
    const distinctProduct = [];
    auxBody.forEach((row) => {
      let found = false;
      const dupRow = { ...row };
      for (let ritem of distinctProduct) {
        if (
          ritem["Product name"] === row["Product name"] &&
          ritem["Compound phase"] === row["Compound phase"] &&
          ritem["Condition treated"] === row["Condition treated"] &&
          ritem["Company Name"] === row["Company Name"] &&
          ritem["NCT link"] === row["NCT link"]
        ) {
          //same product name, compound phase and condition treated, Company Name, and NCT link
          found = true;
          // for first time replace
          if (typeof ritem["Segment"] === "string")
            ritem["Segment"] = [ritem["Segment"], dupRow["Segment"]];
          // second or fruther replace
          else ritem["Segment"].push(row["Segment"]);
          break;
        }
      }
      if (!found) distinctProduct.push(dupRow);
    });
    auxBody = distinctProduct;

    //collecting footnotes
    this.footnotes = collectFootnotes(auxBody, this.footnotesColumnName);

    try {
      // Map coumpund phase to actual phase
      // const mapedToPhase = [];
      // Phase III
      auxBody = auxBody.filter((row) => {
        if (row["Compound phase"].match(/III/)) {
          row["Compound phase"] = "Phase III";
          this.formated["Phase III"].value.push(row);
          return false;
        }
        return true;
      });

      // Phase II
      auxBody = auxBody.filter((row) => {
        if (row["Compound phase"].match(/II/)) {
          row["Compound phase"] = "Phase II";
          this.formated["Phase II"].value.push(row);
          return false;
        }
        return true;
      });

      // Phase I
      auxBody = auxBody.filter((row) => {
        if (row["Compound phase"].match(/I/)) {
          row["Compound phase"] = "Phase I";
          this.formated["Phase I"].value.push(row);
          return false;
        }
        return true;
      });

      // "Pre-clinical"
      auxBody = auxBody.filter((row) => {
        if (row["Compound phase"].toLowerCase().includes("clinical")) {
          this.formated["Pre-Clinical"].value.push(row);
          this.formated["Pre-Clinical"].visibility = true;
          return false;
        }
        return true;
      });

      //Filed
      auxBody = auxBody.filter((row) => {
        if (
          [
            "sNDA",
            "Filed",
            "sNDA (RTF Received)",
            "Filed (CRL Received)",
            "Filed in US (RTF Received), Filed in EU",
            "Filed (RTF Received)",
          ]
            .map((s) => s.toLowerCase())
            .includes(row["Compound phase"].toLowerCase())
        ) {
          this.formated.Filed.value.push(row);
          this.formated.Filed.visibility = true;
          return false;
        }
        return true;
      });

      // "Approved or Marketed"
      auxBody = auxBody.filter((row) => {
        if (
          [
            "Approved",
            "Marketed",
            "Approved in US, Filed in EU",
            "Approved in EU, Filed in US",
            "Marketed in EU, Filed in US",
            "Marketed in US, Filed in EU",
            "Marketed (JP), NDA resubmission in US",
            "Marketed (Russia)",
          ]
            .map((s) => s.toLowerCase())
            .includes(row["Compound phase"].toLowerCase())
        ) {
          this.formated["Approved or Marketed"].value.push(row);
          this.formated["Approved or Marketed"].visibility = true;
          return false;
        }
        return true;
      });

      // push everything left to leftBehind
      if (auxBody.length) {
        auxBody.forEach((row) => this.leftBehind.push(row));
      }

      this.setState({ formated: this.formated });
    } catch (error) {
      alert("This sheet doesn't have all the required data fields!");
      this.props.history.push("/");
      // return;
    }
    // });
  }

  boxSizeChange = (e) => {
    const { boxSize } = this.state;
    // console.log(boxSize)
    boxSize[e.target.name] = e.target.value;
    this.setState({ boxSize });
  };

  switchColor = (e) => {
    this.setState({randomColors: e.target.checked})
  }

  filters = (formated) => (
    <div className="filterContainer" style={{ marginLeft: 10 }}>
      <FormGroup row>
        {formated &&
          Object.keys(this.formated).map((key, index) => {
            return (
              <div key={index}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id={`column-${index}-check`}
                      checked={this.state.formated[key].visibility}
                      type="checkbox"
                      name={key}
                      onChange={this.handleColVisibilityChange}
                    />
                  }
                  label={key}
                />
              </div>
            );
          })}
      </FormGroup>
      <FormGroup row>
        {this.props.config.tm && <RedirectToTm/>}
        <SwitchColor onChange={this.switchColor} checked={Boolean(this.state.randomColors)}></SwitchColor>
      </FormGroup>
    </div>
  )

  render(props) {
    const { formated, boxSize, notAvailable, randomColors } = this.state;
    const id = 'report-1';

    if (notAvailable.length) return InvalidReport({ notAvailable, ...this.props });

    return (
      <div id={id}>
        <ReportBase
          {...this.props}
          exportImg={id}
          filters={this.filters(formated)}
          toolbarRightComponent={(
            <BoxSizeControl
              className="boxSizeControl"
              onChange={this.boxSizeChange}
              value={boxSize}
            />
          )}
        >
          <div id="toImage">
            {formated && (
              <table>
                <thead>
                  <tr>
                    {Object.keys(this.formated).map((key, index) => {
                      if (formated[key].visibility)
                        return <th key={`head-${index}`}>{key}</th>;
                      return null;
                    })}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {Object.keys(this.formated).map((key) => {
                      // let sameProduct = null;
                      if (formated[key].visibility) {
                        return (
                          <td key={key}>
                            <div className="holder">
                              {formated[key].value.map((row, index) => {
                                return (
                                  <div
                                    key={key + index}
                                    style={{
                                      minHeight: boxSize.height + "px",
                                      width: boxSize.width + "px",
                                    }}
                                    className="box"
                                  >
                                    <strong>
                                      {sanitize(row["Product name"])}
                                      {row[this.footnotesColumnName] && (
                                        <span className="footnotesIndex">
                                          {row[this.footnotesColumnName]
                                            .split("|")
                                            .map((note) => {
                                              let index = -1;
                                              this.footnotes.some((n, i) => {
                                                if (n.text === note.trim()) {
                                                  index = i;
                                                  return true;
                                                }
                                                return false;
                                              });
                                              if (index === -1) return null;
                                              return (
                                                <span key={index}>
                                                  ({index + 1})
                                                </span>
                                              );
                                            })}
                                          {/* (
                                        {this.footnotes.indexOf(
                                          row[this.footnotesColumnName]
                                        ) + 1}
                                        ) */}
                                        </span>
                                      )}
                                    </strong>
                                    <p className="for-image">{row["MOA (Revised)"]}</p>
                                    <p className="for-image">
                                      {row["Company Name"]}
                                    </p>
                                    {typeof row["Segment"] === "string" &&
                                      row["Segment"] && (
                                        <Segment segment={row['Segment']} distinctSegments={this.distinctSegments} colors={randomColors} />
                                      )}
                                    {typeof row["Segment"] === "object" &&
                                      row["Segment"].map((seg, segin) => (
                                        <p key={seg + segin}>
                                          <Segment segment={seg} distinctSegments={this.distinctSegments} colors={randomColors} />
                                          {/* <span
                                            style={{
                                              backgroundColor: "red",
                                              color: "white",
                                            }}
                                            className="badge badge-danger"
                                          >
                                            {mapSegment(seg)}
                                          </span> */}
                                        </p>
                                      ))}
                                  </div>
                                );
                              })}
                            </div>
                          </td>
                        );
                      }
                      return null;
                    })}
                  </tr>
                </tbody>
              </table>
            )}

            {formated && (
              <Footnotes
                general={this.generalFootnotes}
                notes={this.footnotes}
              ></Footnotes>
            )}
          </div>

        </ReportBase>

        {formated && (
          <InvalidRecords
            headers={this.invalidHeaders}
            totalRecord={this.data.length - 1}
            leftBehind={this.leftBehind.map((row) =>
              this.invalidHeaders.map((v) => row[v])
            )}
          />
        )}
        {!formated && (
          <SkeletonTheme color="#E2DEDE">
            <p>
              <Skeleton height={100} />
              <br />
              <br />
              <Skeleton count={8} height={60} />
            </p>
          </SkeletonTheme>
        )}
      </div>
    );
  }

  handleColVisibilityChange = (e) => {
    const key = e.target.name;

    const formated = { ...this.state.formated };
    formated[key] = {
      visibility: e.target.checked,
      value: formated[key].value,
    };
    this.setState({ formated });
  };
}

export default AtaxiaCompetitorUniverse
